import { PhoneTabs } from '~/routes/remote-mic/remote-mic';

// Tab order, which is also the order of the swipe track's panels - the two cannot be allowed to
// disagree, so there is one list.
export const PHONE_TABS: PhoneTabs[] = ['microphone', 'song-list', 'settings'];
